import { render, staticRenderFns } from "./IncomeStatistics1.vue?vue&type=template&id=19063565&scoped=true&"
import script from "./IncomeStatistics1.vue?vue&type=script&lang=js&"
export * from "./IncomeStatistics1.vue?vue&type=script&lang=js&"
import style0 from "./IncomeStatistics1.vue?vue&type=style&index=0&id=19063565&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19063565",
  null
  
)

export default component.exports